import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DynamicDashboard from './DynamicDashboard';
import { DashboardFiltersProvider } from './contexts/DashboardFiltersContext';

/**
 * Dashboard List (Full Dashboard)
 *
 * Renders the customizable dashboard with drag-and-drop widgets.
 * Use ?dashboard=Name in the URL to show a specific saved dashboard (e.g. ?dashboard=Financial).
 * Time range and scope filters at top apply to widgets that support them.
 */
const List: React.FC = () => {
  const [searchParams] = useSearchParams();
  const layoutName = searchParams.get('dashboard') ?? undefined;

  return (
    <DashboardFiltersProvider>
      <DynamicDashboard layoutName={layoutName} />
    </DashboardFiltersProvider>
  );
};

export default List;
